import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animations-test',
  templateUrl: './animations-test.component.html',
  styleUrls: ['./animations-test.component.scss']
})
export class AnimationsTestComponent implements OnInit {

  gridColumns = ["flex-grid-4","flex-grid-3", "flex-grid-2", "flex-grid-1", "flex-grid-5", "flex-grid-2-1"];
  gridColumnsSelected = "";

  constructor() { }

  ngOnInit() {
  }

}
